import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import * as Sentry from '@sentry/browser';
import LogRocket from 'logrocket';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import {history} from './extendedBrowserRouter'
import { Provider } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import ZH_WORDS from './assets/i18n/zh.json';
import EN_WORDS from './assets/i18n/en.json';
import store from './store/Store.js';
import App from './App';
import 'antd/dist/antd.css';
import './assets/css/common.css';

Sentry.init({dsn: "https://0c2b1fffcf04412d9cd3c1098d575ace@sentry.io/1837969"});
//LogRocket.init('fydaja/vedic');
LogRocket.init('156fup/vedic');
if (process.env.NODE_ENV === 'production') {
  disableReactDevTools();
}

addLocaleData([...en, ...zh]);

history.listen((location, action) => {
  window.scrollTo(0, 0)
})

const userLang = navigator.language || '';
const language = userLang.toLowerCase().substr(0, 2);
let locale;
let messages;

if (language === 'zh') {
  locale = 'zh';
  messages = ZH_WORDS;
} else if (language === 'en') {
  locale = 'en';
  messages = EN_WORDS;
}

store.firebaseAuthIsReady.then(() => {
  ReactDOM.render(
    <IntlProvider locale={locale} messages={messages}>
      <Provider store={store}>
        <Router history={history}>
          <App />
        </Router>
      </Provider>
    </IntlProvider>,
    document.getElementById('root')
  );
});
